module.exports = __webpack_public_path__ + "img/en_get.ad3e312.png";